import { render, staticRenderFns } from "./Funds.vue?vue&type=template&id=6dd323b3"
import script from "./Funds.vue?vue&type=script&lang=js"
export * from "./Funds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports